var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('FindFormSimple'),_c('Discover'),_c('FindGrid'),_c('FindList'),_c('AppSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }